import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.deliveries')
  .service('RecurringServicesAPI', RecurringServicesAPI);

function RecurringServicesAPI(): BringozApi {
  return {
    base: `/services/recurring`,
    infiniteScroll: {
      address: `/services/recurring`,
      cmd: 'GET'
    }
  }
}
